import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

const TempCake = ({ flavor, size, toppings, accessories, textToAdd }) => {
  let total = 0;

  if (flavor.pricePerKg) {
    total = size * flavor.pricePerKg;
  }
  toppings.map((topping) => {
    total = total + topping.price;
  });
  accessories.map((accessory) => {
    total = total + accessory.price;
  });

  return (
    <CakeContainer>
      <div className="price-details">
        <p className="title">Your Choices</p>
        {total > 0 && <p className="title">{`Rs ${total}`}</p>}
      </div>
      <div className="choices">
        {size !== 0 && (
          <>
            <p className="heading">Size</p>

            <motion.p
              initial={{ x: 200, opacity: 0, scale: 0.8 }}
              animate={{ x: 0, opacity: 1, scale: 1 }}
              transition={{ duration: 0.5 }}
            >
              {size} Kg
            </motion.p>
          </>
        )}
        {flavor.name && (
          <>
            <p className="heading">Flavor</p>

            <motion.p
              initial={{ x: 200, opacity: 0, scale: 0.8 }}
              animate={{ x: 0, opacity: 1, scale: 1 }}
              transition={{ duration: 0.5 }}
            >
              {flavor.name}
            </motion.p>
          </>
        )}

        {toppings.length > 0 && (
          <>
            <p className="heading">Toppings</p>
            <div className="toppings">
              {toppings.map((topping) => {
                return (
                  <motion.p
                    initial={{ x: 200, opacity: 0, scale: 0.8 }}
                    animate={{ x: 0, opacity: 1, scale: 1 }}
                    transition={{ duration: 0.5 }}
                    className="topping-tag"
                  >
                    {topping.name}
                  </motion.p>
                );
              })}
            </div>
          </>
        )}
        {accessories.length > 0 && (
          <>
            <p className="heading">Accessories</p>
            <div className="toppings">
              {accessories.map((accessory) => {
                return (
                  <motion.p
                    initial={{ x: 200, opacity: 0, scale: 0.8 }}
                    animate={{ x: 0, opacity: 1, scale: 1 }}
                    transition={{ duration: 0.5 }}
                    className="topping-tag"
                  >
                    {accessory.name}
                  </motion.p>
                );
              })}
            </div>
          </>
        )}
        {textToAdd !== "" && (
          <>
            <p className="heading">Wordings</p>

            <motion.p
              initial={{ x: 200, opacity: 0, scale: 0.8 }}
              animate={{ x: 0, opacity: 1, scale: 1 }}
              transition={{ duration: 0.5 }}
              className="text"
            >
              {textToAdd}
            </motion.p>
          </>
        )}
      </div>
    </CakeContainer>
  );
};

export default TempCake;

const CakeContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .price-details {
    display: flex;
    justify-content: space-between;
  }
  .title {
    margin: 0;
    font-size: 25px;
    font-weight: 900;
  }

  .toppings {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }

  .topping-tag {
    margin: 0;
    border: 1px solid;
    padding: 5px;
    border-radius: 10px;
    font-size: 13px;
    background-color: #ebd5ce;
  }
  .heading {
    font-weight: 900;
    font-size: 17px;
  }
`;
